import React, { Fragment } from 'react';
import { Row, Col } from 'react-bootstrap';
import '../../../styles/itens.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as FontAwesomeIcons from '@fortawesome/free-solid-svg-icons';


const Item = (props) => {
    const Icone = FontAwesomeIcons[props.awesome];
    console.log(Icone)
    return (
        <Fragment>
            <div className="filtra_lic">
                <div className="titulo-home">{props.titulo}</div><br />
                <a className='link-lic' href={props.link}>
                    <div className="conteudo-home">
                        <Row xs={1}>
                            {props.img ?
                                <Col xs={12}>
                                    <img className='icons-transp' src={props.img} alt={props.titulo} />
                                </Col> : ''}
                            {props.awesome ?
                                <Col xs={12}>
                                    <FontAwesomeIcon className='icone-principal' icon={Icone} />
                                </Col> : null}
                            <Col xs={12}>
                                <p>{props.descricao}</p>
                            </Col>
                        </Row>
                    </div>
                </a>
            </div>
        </Fragment>
    );
}

export default Item;